import styled from 'styled-components';

export const ActivityContainer = styled.div`
  padding: 1rem;
  max-height: 500px;
  overflow-y: auto;
`;

export const ActivityItem = styled.div<{ isLatest: boolean }>`
  border-left: ${(props) => (props.isLatest ? '4px solid #21ba45' : '4px solid #e0e0e0')};
  padding-left: 1rem;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ActivityHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f0f0f0;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
`;

export const ActivityHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 6px;
  }
`;

export const ActivityHeaderRight = styled.div`
  font-size: 0.8rem;
  color: #666;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 0.75rem;
    margin-top: 2px;
  }
`;

export const ActivityContent = styled.div`
  padding: 0.5rem 0;
  font-size: 0.9rem;
  line-height: 1.4;
`;

export const ActivitySectionTitle = styled.div`
  margin-bottom: 8px;
`;

export const ActivityField = styled.div`
  margin-bottom: 4px;
`;

export const ActivityMeta = styled.div`
  margin-top: 8px;
  font-style: italic;
  color: #666;
`;

export const EmptyStateContainer = styled.div`
  text-align: center;
  padding: 2rem;
  color: #666;
`;

export const EmptyStateIcon = styled.div`
  margin-bottom: 1rem;
`;

export const LoadingContainer = styled.div`
  padding: 2rem;
  text-align: center;
`;
